export default {
  'Settings.FormatDropdown': ({ selectedOptionIds, format, frequency, occurrenceValues, hour, minute, ampm }, outlet, internalStateSetter) => {
    internalStateSetter({ format: format === selectedOptionIds[0] ? null : selectedOptionIds?.[0] ?? null, formatError: '' })
    outlet({ format: format === selectedOptionIds[0] ? null : selectedOptionIds?.[0] ?? null, frequency, occurrenceValues, hour, minute, ampm })
  },
  'Settings.FrequencyDropdown': ({ selectedOptionIds, frequency, occurrenceValues, format, hour, minute, ampm }, outlet, internalStateSetter) => {
    internalStateSetter({
      frequency: frequency === selectedOptionIds[0] ? null : selectedOptionIds?.[0] ?? null,
      occurrenceValues: frequency === selectedOptionIds[0] ? occurrenceValues : [],
      frequencyError: '', occurrenceError: ''
    });
    outlet({
      format,
      frequency: frequency === selectedOptionIds[0] ? null : selectedOptionIds?.[0] ?? null,
      occurrenceValues: frequency === selectedOptionIds[0] ? occurrenceValues : [],
      hour, minute, ampm
    })

  },
  'Settings.Recurrence': ({ occurrenceValues, format, frequency, hour, minute, ampm }, outlet, internalStateSetter) => {
    internalStateSetter({ occurrenceValues, occurrenceError: '' });
    outlet({ format, frequency, occurrenceValues, hour, minute, ampm })
  },
  'Settings.TimeSelector.HourInput': ({ value, format, frequency, occurrenceValues, minute, ampm }, outlet, internalStateSetter) => {

    let val = value;

    if (/^\d{1,2}$/.test(value)) {
      const numValue = parseInt(value, 10);
      if (numValue < 0 || numValue > 12) {
        val = '';
      } else if (value.length === 1 && value !== '0' && value !== '1') {
        val = '0' + value;
      }
    } else {
      val = '';
    }

    internalStateSetter({ hour: val, timeError: '' });
    outlet({ format, frequency, occurrenceValues, hour: val, minute, ampm })

  },
  'Settings.TimeSelector.MinuteInput': ({ value, format, frequency, occurrenceValues, hour, ampm }, outlet, internalStateSetter) => {
    let val = value;

    if (/^\d{1,2}$/.test(value)) {
      const numValue = parseInt(value, 10);
      if (numValue < 0 || numValue > 59) {
        val = '';
      } else if (value.length === 1 && numValue > 5) {
        val = '0' + value;
      }
    } else {
      val = '';
    }

    internalStateSetter({ minute: val });
    outlet({ format, frequency, occurrenceValues, hour, minute: val, ampm })
  },
  'Settings.TimeSelector.AmPm': ({ selectedId, format, frequency, occurrenceValues, hour, minute }, outlet, internalStateSetter) => {
    internalStateSetter({ ampm: selectedId });
    outlet({ format, frequency, occurrenceValues, hour, minute, ampm: selectedId })

  },
  'Settings.Submit': ({ format, frequency, occurrenceValues, hour, minute, ampm }, outlet, internalStateSetter) => {
    if (!format) {
      internalStateSetter({ formatError: 'Please select format' })
    }
    if (!frequency) {
      internalStateSetter({ frequencyError: 'Please select frequency' })
    }
    if (frequency !== 'daily' && occurrenceValues.length === 0) {
      internalStateSetter({ occurrenceError: 'Please select occurrence' })
    }
    if (!hour || !minute) {
      internalStateSetter({ timeError: 'Please complete time' })
    }
    if (!format || !frequency || !hour || !minute || frequency !== 'daily' && occurrenceValues.length === 0) {
      return;
    }
    outlet({ format, frequency, occurrenceValues, hour, minute, ampm, action: 'subscribe' })
  },
  'Settings.Deactivate': ({ id }, outlet) => {
    outlet({ id, action: 'deactivate' })
  }
}
